import React from "react";
import {Alert, Box, Button, LinearProgress} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function NotificationOrderFeedback({status}) {
    const {t} = useTranslation();
    return <>
        <Box sx={{position: "relative", height: 0}}>
            {status.loading && <LinearProgress sx={{position: "absolute", inset: "0 0 auto", zIndex: 1}}
                aria-label={t("NotificationOpeningOrder")}/>}
        </Box>
        {status.error && <Alert severity="error" action={<Button color="inherit" onClick={status.retry}>{t("Retry")}</Button>}>{t(status.error)}</Alert>}
    </>;
}
